import { ChangeEvent, FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { FieldErrors, UseFormSetValue } from "react-hook-form";

import { InputField } from "@/components/InputField/InputField";
import { Information } from "@/components/Information/Information";

import { CreateLiPost } from "../schema/liPost";

interface ProfileQueryFieldProps {
	formValues: Partial<CreateLiPost>;
	setValue: UseFormSetValue<CreateLiPost>;
	errors: FieldErrors<CreateLiPost>;
}

/** BY_PROFILE optional Boolean keyword query with usage help. */
export const ProfileQueryField: FunctionComponent<ProfileQueryFieldProps> = ({
	formValues,
	setValue,
	errors,
}) => {
	const { t } = useTranslation();
	const ts = (key: string) => t(`liPost.${key}`);

	return (
		<div className="flex flex-col w-full mb-8">
			<InputField
				error={!!errors.query?.message}
				handleChange={(event: ChangeEvent<HTMLInputElement>) => {
					setValue("query", event.target.value, { shouldDirty: true, shouldValidate: true });
				}}
				label={ts("query")}
				name={"query"}
				placeholder={ts("queryPlaceholder")}
				showError={!!errors.query?.message}
				value={formValues?.query || ""}
			/>
			<div className="text-xs text-text-meta">
				You can run a Boolean search for LinkedIn posts by combining keywords with operators like
				AND, NOT, and OR written in capital letters and use quotation marks (“keyword”) to search
				for exact phrases and parentheses to make even more complex searches.{" "}
				<Information information="For example: Sales OR Marketing will return posts that have either of those keywords. (Sales OR Marketing) AND AI will return posts that contain “AI” and either “Sales” or “Marketing." />
			</div>
		</div>
	);
};
